import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

new Swiper('.swiper-feedback', {
  navigation: {
    nextEl: '.swiper-feedback-button-next',
    prevEl: '.swiper-feedback-button-prev',
  },
  slidesPerView: 'auto',
  loop: true,
  initialSlide: 1,
  spaceBetween: 24,
  centeredSlides: true,
});

new Swiper('.swiper-address', {
  navigation: {
    nextEl: '.swiper-address-button-next',
    prevEl: '.swiper-address-button-prev',
  },
  slidesPerView: 1,
  loop: true,
  spaceBetween: 24,
  centeredSlides: true,
});
